<template>
  <sui-segment raised>
    <h1>LAN1 Hotspots | Voucher Shop</h1>
    <sui-grid :columns="3" stackable>
      <sui-grid-column v-for="(item, key) in $store.getters.allVouchers" :key="key">
        <Product :item="item" />
      </sui-grid-column>
    </sui-grid>
    <sui-dimmer :active="$store.getters.isLoading">
      <sui-loader>{{ $t('strLoading') }}</sui-loader>
    </sui-dimmer>
  </sui-segment>
</template>

<script>
  import Product from '@/views/components/Product.vue';

  export default {
    name: 'Home',
    metaInfo() {
      return {
        title: 'LAN1 Hotspots - Vouchershop',
        meta: [
          { vmid: 'description', name: 'description', content: 'Ihr Voucher-Angebot: Online-Zeit kaufen und kabellos an allen LAN1 Standorten surfen. Bestellen Sie jetzt im LAN1 Onlineshop!' }
        ]
      }
    },
    components: {
      Product
    },
    data() {
      return {
        loading: true,
        token: '',
        voucher: [],
        someVoucherName: 'SomeVoucher 12 Tage',
      }
    },
    async created() {
      await this.$store.dispatch('fetchVouchers')
      if (this.$store.getters.errorMsg) {
        this.$swal(this.$t('error'), this.$t(this.$store.getters.errorMsg), 'error')
      }
    },
  }
</script>
<style lang="scss" scoped>
  h1{
    display: none;
  }
</style>
